import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setStaticDocumentTitle } from '../hooks/useDocumentTitle';
import { resolveDocumentTitleFromPath } from '../utils/documentTitle';

/** Sets the default browser tab title from the current route. Detail pages override via `useDocumentTitle`. */
export function RouteDocumentTitle() {
  const location = useLocation();
  const staticFromPath = resolveDocumentTitleFromPath(location.pathname, location.search);

  useLayoutEffect(() => {
    setStaticDocumentTitle(staticFromPath);
  }, [staticFromPath]);

  return null;
}
